import React from 'react';

const LoadingSpinner = () => (
  <div className="spinner-container" style={{ minHeight: '100vh' }}>
    <div className="spinner" />
  </div>
);

export default LoadingSpinner;
